import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import JournalComponent from 'components/journal/journal';
import { getAllCheckins, deleteCheckin } from '../../actions/checkin';

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getAllCheckins,
        deleteCheckin
    }, dispatch);
}

function mapStateToProps(state) {
    return {
        checkins: state.checkins,
        currentUser: state.currentUser
    };
}

const Journal = connect(
    mapStateToProps,
    mapDispatchToProps
)(JournalComponent);

export default Journal;


// WEBPACK FOOTER //
// ./src/app/containers/journal/journal.jsx